import { Box } from '@mui/material';
import * as Sentry from '@sentry/react';
import { Accounting } from '../modules/accounting';
import { accountingLoadError } from '../modules/accounting/constants/strings/errors';

export const AccountingPage = (): JSX.Element => (
  <Sentry.ErrorBoundary fallback={<Box>{accountingLoadError}</Box>}>
    <Accounting />
  </Sentry.ErrorBoundary>
);
